import { Comercial } from './Comercial';
import { EstadoFiltro } from "@shared/enums/EstadoFiltro";
import { UsuarioDTO } from "@shared/models/notificaciones";

export class FiltroReporteSaldo {
    estados: EstadoFiltro[];
    comerciales: Comercial[];
    ejecutivos: UsuarioDTO[];
    filtroTexto: string;
    usuario: UsuarioDTO | null;
    esAprobador: boolean;
}
